/*
  Merge objects, like Object.assign, but never changes the objects
  (a copy is always made if the object needs to be changed).

  This function always returns an object. The first parameter MUST be a
  non-array object.
 */
function deepMerge(state?: {}, mergeObject?: {}): {} {
  if ((state && typeof state !== 'object') || Array.isArray(state)) {
    throw new TypeError(
      `invalid parameter type: '${Array.isArray(state) ? 'array' : typeof state}'`,
    );
  }

  if (typeof mergeObject !== 'object' || mergeObject === null) {
    return state || {};
  }

  const mergeKeys = Object.keys(mergeObject);
  if (mergeKeys.length <= 0) {
    return state || {};
  }

  if (!state) {
    return { ...mergeObject };
  }

  const returnState = { ...state };

  for (let i = 0; i < mergeKeys.length; i++) {
    const key = mergeKeys[i];
    if (mergeObject[key] === null) {
      returnState[key] = null;
    } else if (
      !Object.prototype.hasOwnProperty.call(returnState, key) ||
      typeof mergeObject[key] !== 'object' ||
      Array.isArray(mergeObject[key])
    ) {
      returnState[key] = mergeObject[key];
    } else {
      returnState[key] = deepMerge(returnState[key], mergeObject[key]);
    }
  }

  return returnState;
}

export default deepMerge;
